import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

Vue.component("classification-system-items-treeview-select", {
	components: { Treeselect },
	props: [
		"classificationSystemId",
		"value",
		"language",
		"guid",
		"placeholder",
	],
	data() {
		return {
			loading: false,
			loadingText: window.labels.loading,
			myValue: this.value,
			classificationSystemItems: [],
			searchWrapperInjected: false,
		}
	},
	mounted() {
		if(this.classificationSystemId) {
			this.refreshItems(this.classificationSystemId);
		}
	},
	watch: {
		myValue: function (value) {			
			if (value != this.value) {
				console.log(value);
				this.$emit('update:value', value);
			}
		},
		classificationSystemId: function(value) {
			this.refreshItems(value);
		}
	},
	methods: {
		refreshItems(classificationSystemId) {
			this.loading = true;
			this.searchWrapperInjected = false;
			this.$services.classificationHierarchies.getDropdownItems({
				classificationSystemId: classificationSystemId,
				language: this.language,
			}).then((data) => {

					if (data != null) {						
						this.classificationSystemItems = data;
					}
					this.loading = false;
				});
		},
		injectSearchWrapper() {
			if(!this.searchWrapperInjected) {
				this.searchWrapperInjected = true;
				let initialHandleLocalSearch = this.$refs.treeselect.handleLocalSearch;
				this.$refs.treeselect.handleLocalSearch = function () {
					const minLength = 3;
					let searchQuery = this.trigger.searchQuery;
					this.rootOptionsStates.loadingError = "";

					if (searchQuery.length && searchQuery.length < minLength) {
						this.rootOptionsStates.loadingError = (
							htmlEntity.decode(window.labels.treeSelectMinlengthError.replace("##error##", minLength))
						);
					} else {
						initialHandleLocalSearch.call(this);
					}
				};
			}
		},
		normalizer(node) {
			return {
				children: node.children && node.children.length ? node.children : 0
			}
		},
		onMenuOpen() {
			this.injectSearchWrapper();
		},
	},
	template: `
      	<div :id="guid">
	  		<template v-if="loading"><loading></loading></template>
			<template v-else>
				<treeselect 
					v-model="myValue"
					ref="treeselect"
					@open="onMenuOpen"
					:multiple="true" 
					:options="classificationSystemItems"
					:disable-fuzzy-matching="true"
					:loading-text="loadingText"
					:normalizer="normalizer"
					:placeholder="placeholder"
				/>
			</template>
      </div>
	`
});
